import { Alert, CircularProgress, Box } from "@mui/material";
import { CampaignLayout } from "Components/Layout/CampaignLayout";
import { useCampaignByCodeQuery } from "Api/Queries/Campaigns/useCampaignByCodeQuery";
import { getCampaignImages } from "Utils/Campaigns/campaignImageMapping";
import { getCampaignImageUrl } from "Api/Queries/Campaigns/useCampaignImageUrl";
import { CampaignImageType } from "Infrastructure/Api/Api";
import { useParams } from "react-router";
import { Resources, useResource } from "Translations/Resources";
import { CampaignPageContent } from "Components/Campaigns/CampaignPageContent";

const RESOURCES = Resources.Campaigns.Campaign.Page;

export const CampaignPage = () => {
  const { code } = useParams<{ code: string }>();
  const { t } = useResource();
  // const [searchParams] = useSearchParams();
  // const affiliateCode = searchParams.get(LocalStorageKeys.AffiliateCode); // campaigns currently don't match affiliate codes (charity)

  const { data: campaign, isLoading, isError } = useCampaignByCodeQuery(code);

  // useEffect(() => {
  //   if (affiliateCode) {
  //     setLocalStorageItem(LocalStorageKeys.AffiliateCode, affiliateCode);
  //   }
  // }, [affiliateCode]);

  if (isLoading) {
    return (
      <CampaignLayout title={t(RESOURCES.Loading)}>
        <Box display="flex" justifyContent="center" py={10}>
          <CircularProgress />
        </Box>
      </CampaignLayout>
    );
  }

  if (isError || !campaign) {
    return (
      <CampaignLayout title={t(RESOURCES.CampaignNotFound)}>
        <Alert severity="error">{t(RESOURCES.CampaignNotFoundMessage)}</Alert>
      </CampaignLayout>
    );
  }

  const apiLogoUrl = getCampaignImageUrl(campaign, CampaignImageType.Logo);
  const hardcodedImages = getCampaignImages(campaign.code);
  const logoSrc = apiLogoUrl || hardcodedImages?.logo;

  const logo = logoSrc
    ? {
        src: logoSrc,
        alt: `${campaign.name} logo`,
        width: 45,
        height: 45,
      }
    : undefined;

  return (
    <CampaignLayout title={campaign.name} secondaryLogo={logo}>
      <CampaignPageContent campaign={campaign} />
    </CampaignLayout>
  );
};

export default CampaignPage;
